<template>
  <div class="phone-city" ref="phoneCityIndex" :class="[industryBool?'hiddenY':'']">
    <transition enter-active-class="animated fadeInRight" leave-active-class="animated slideOutLeft">
      <city-address v-if="addressShowBool" :current-page="currentPage" @currentParams="currentParamsVal"></city-address>
    </transition>
    <transition enter-active-class="animated fadeInRight" leave-active-class="animated slideOutLeft">
      <industry-list v-if="industryBool" @industryBool="industryBoolVal" :parameter="parameter" :current-page-bool="currentPageBool"></industry-list>
    </transition>
    <div class="top">
      <div class="posRe">
        <div class="type" @click="industryListFun"><p>行业</p><p>分类</p></div>
        <div class="top-search">
          <i class="icon-img icon-search"  @click="searchBtn"></i>
          <input type="text"
                 v-model="searchVal"
                 placeholder="请输入关键字"
                 @keyup.enter="searchBtn"
          >
        </div>
        <div class="city-address oneRow" @click="addressPage">{{currentAddress.name}}<i class="icon-img icon-down-white"></i></div>
      </div>
    </div>
    <pan :state="state" @addressCurrent="addressCurrent"></pan>
    <div class="center">
      <div class="city-tab" ref="centerPos">
        <span :class="[tabIndex==0?'active':'']"
            @click="tabClick('PanoWebService.asmx/GetRecommendByCity',0)"
        >推荐全景</span>
        <span :class="[tabIndex==1?'active':'']"
              @click="tabClick('PanoWebService.asmx/GetLatestByCity',1)"
        >最新全景</span>
      </div>
      <div>
        <p-title  class="title-top" :title="tabIndex==1?titleNew:titleRecommend"></p-title>
        <template v-if="lists&&lists.length">
          <div>
            <template v-for="(list, index) in lists">
              <only-list :default-bool="list.defaultBool?true:''" :item="list" :lazy="lazy" :class-name="className+'-'+tabIndex+'-'+index" :key="'cityList'+tabIndex+index"></only-list>
            </template>
            <transition enter-active-class="animated fadeInUp" leave-active-class="animated slideOutdown">
              <template v-if="loadingDataBool&&lists.length<total">
                <div class="loading-more">
                  <div>加载更多<i class="icon-img icon-more"></i></div>
                </div>
              </template>
            </transition>
          </div>
        </template>
        <template v-else>
          <div class="phone-no-data">
            <img :src="$noData" alt="">
            <p>抱歉，暂无相关内容</p>
          </div>
        </template>
      </div>
    </div>

    <transition enter-active-class="animated fadeInRight" leave-active-class="animated zoomOut">
      <template v-if="topBool">
        <div class="down-to-top icon-img" @click="publicJs.downToUp(1)"></div>
      </template>
    </transition>
    <p-footer></p-footer>
  </div>
</template>

<script>
import pan from '@/components/Phone/pan'
import pTitle from '@/components/title'
import onlyList from '@/components/onlyList'
import cityAddress from '@/components/Phone/cityAddress.vue'
import industryList from '@/components/Phone/industryList.vue'
import pFooter from '@/components/footer'
export default {
  name: 'phoneIndex',
  props: [''],
  inject: ['reload'],
  data () {
    return {
      state: 2,
      titleRecommend: {
        title: '<span>推荐</span>全景'
      },
      titleNew: {
        title: '<span>最新</span>全景'
      },
      searchVal: '',
      industryList: [],
      industryBool: false,
      currentPageBool: false,
      url: 'PanoWebService.asmx/GetRecommendByCity',
      className: '-city-recommend',
      tabIndex: 0,
      addressShowBool: false,
      currentPage: 'city',
      currentAddress: {},
      parameter: {
        cityId: 0,
        cityIndex: -1,
        countyIndex: -1,
        topIndex: -1,
        typeId: 0
      },
      lazy: {
        bool: false
      },
      page: 1,
      limit: 8,
      total: 0,
      loadingDataBool: false,
      lists: [],
      topBool: false,
      defaultData:[
        {name: "",defaultBool:true},
        {name: "",defaultBool:true},
        {name: "",defaultBool:true},
        {name: "",defaultBool:true},
      ]
    }
  },
  components: {
    pan: pan,
    pTitle: pTitle,
    onlyList: onlyList,
    cityAddress: cityAddress,
    industryList: industryList,
    pFooter: pFooter
  },
  created () {
    let that = this;
    that.parameter = this.publicJs.decodeFun(that.$route.query);
    that.$emit('topState', 2);
    that.httpData(1);
    that.$nextTick(function () {
      let b = that.$refs.phoneCityIndex;
      b.addEventListener('scroll', this.handleScroll)
    })
  },
  mounted () {
    this.industryData();
    this.listScrollb()
  },
  methods: {
    handleScroll: function () {
      let that = this;
      let b = that.$refs.phoneCityIndex;
      let scrollTop = b.pageYOffset || b.scrollTop;
      if (scrollTop > 344) {
        if (!that.topBool) that.topBool = true
      } else {
        that.topBool = false
      }
    },
    addressCurrent: function (val) {
      this.currentAddress = val;
      this.parameter.cityId = val.cityId;
      this.publicJs.changeDocumentTitle(val.name,val.cityId)
    },
    searchBtn: function () {
      let that = this;
      let currentParams = JSON.parse(this.publicJs.decode(that.$route.query));
      that.$router.push({
        path: '/searchIndex',
        query: {
          key: that.publicJs.encode(JSON.stringify({
            typeId: 0,
            cityIndex: currentParams.cityIndex,
            keyWords: that.searchVal,
            countyIndex: currentParams.countyIndex,
            topIndex: -1
          })),
          '_': new Date().getTime()
        }
      })
      that.searchVal = ''
    },
    industryBoolVal: function (val) {
      this.industryBool = false
    },
    industryListFun: function () {
      let that = this;
      that.industryBool = true
    },
    currentParamsVal: function (val) {
      this.addressShowBool = val
    },
    industryData: function () {
      let that = this;
      that.publicJs.navGetData(function (data) {
        if (data.code === 1) {
          that.industryList = data.data.concat(that.industryList)
        }
      })
    },
    tabClick: function (url, n) {
      this.tabIndex = n;
      this.page = 1;
      this.className = (n === 1 ? '-city-new' : '-city-recommend');
      this.url = url;
      $('.app-content').animate({scrollTop: 200}, 500)
    },
    addressPage: function () {
      let that = this;
      that.addressShowBool = true
    },
    httpData: function (n) {
      let that = this;
      let params = {
        cityId: that.parameter.cityId,
        typeId: that.parameter.typeId,
        page: n,
        limit: that.limit,
        keyWords: ''
      }
      that.httpAjax.getAjax(that.url, params).then(function (data) {
        if (data.code === 1) {
          that.total = data.total;
          let currentData = JSON.parse(JSON.stringify(data.data));
          if(that.total>4){
            that.lists = that.lists.concat(currentData);
          }else {
            that.lists=currentData.concat(that.defaultData.slice(0,4-that.total))
          }
          that.loadingDataBool = false
        }
      }, function (err) {
        console.log(err)
      })
    },
    listScrollb: function () {
      let that = this
      that.$nextTick(function () {
        $('.phone-city').scroll(function (e) {
          if (!that.loadingDataBool) {
            if (that.publicJs.isScrollBottom(this, 0.98)) {
              let p = that.page;
              let l = that.limit;
              that.loadingDataBool = true;
              if (p && l && (p * l < that.total)) {
                setTimeout(function () {
                  that.page++
                  that.httpData(that.page)
                }, 240)
              } else {
                that.loadingDataBool = false
              }
            }
          }
        })
      })
    }
  },
  watch: {
    parameter: {
      handler: function (a, b) {
        // let that = this
        // that.industryData()
        if (a !== b) {
        }
      },
      deep: true
    },
    url: {
      handler: function (a, b) {
        if (a !== b) {
          this.page = 1
          this.lists = []
          this.loadingDataBool = false
          this.httpData(1)
        }
      },
      deep: true
    },
    '$route': {
      handler: function (a, b) {
        if (a !== b) {
          this.reload();
          this.$root.panIndex=0;
        }
      },
      deep: true
    }
  },
  destroyed () {
    let that = this
    let b = that.$refs.phoneCityIndex
    if (b) {
      b.addEventListener('scroll', this.handleScroll)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .phone-city{
    -webkit-animation: faseInLeft 0.5s;
    -o-animation: faseInLeft 0.5s;
    animation: faseInLeft 0.5s;
  }
  .top{
    position: fixed;
    top:0;
    left: 0;
    width: 100%;
    z-index: 4;
    background-color: #248DDF;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .top>div{
    padding: 8px 95.5px 8px 52.5px;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 14px;
  }
  .top .type{
    position: absolute;
    left: 10px;
  }
  .top .type p{
    border-bottom: 1px solid #fff;
  }
  .top-search{
    height: 28px;
    background: #FFFFFF;
    border-radius: 14px;
    padding-left: 34px;
    padding-right: 14px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }
  input::placeholder{
    color: #999999;
  }
  .top-search input{
    display: block;
    width: 100%;
    height: 100%;
    font-size: 14px;
  }
  .icon-search{
    position: absolute;
    left: 10px;
    top:4px;
  }

  .top .city-address{
    position: absolute;
    right: 10px;
    top:15px;
    font-size: 15px;
    color: #FFFFFF;
    padding-right:20px;
    width: 4rem;
    text-align: right;
  }
  .city-address .icon-down-white{
    position: absolute;
    right: 0;
    top:4px;
     opacity: 0.6;

  }
  .center{
    padding: 15px 11px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .city-tab{
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }
  .city-tab>span{
    width: 48%;
    text-align: center;
    border: 1px solid #248DDF;
    color: #248DDF;
    border-radius: 3px;
    padding: 0.8rem;
    font-size: 14px;
    letter-spacing: 1px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .city-tab>span.active{
    background-color: #248DDF;
    color: white;
  }
  .phone-no-data{
    margin-top: 5%;
  }
  .list-city-recommend{
    -webkit-animation: slideInUp 0.5s ease-in-out;
    -o-animation: slideInUp 0.5s ease-in-out;
    animation: slideInUp 0.5s ease-in-out;
  }
  .list-city-new{
    -webkit-animation: fadeInUp 0.5s ease-in-out;
    -o-animation: fadeInUp 0.5s ease-in-out;
    animation: fadeInUp 0.5s ease-in-out;
  }
</style>



// WEBPACK FOOTER //
// src/Phone/city/index.vue